<template>
  <v-card flat class="ma-2 pa-2 card-rounded">
    <v-card-actions class="mb-2">
      <div class="d-flex overflow-hidden card-rounded border grey--border">
        <v-text-field
          class="mx-1"
          v-model="search"
          prepend-inner-icon="search"
          :label="$t('common.Search')"
          single-line
          hide-details
          solo
          flat
        />
      </div>
      <v-spacer />
      <div class="d-flex overflow-hidden card-rounded border grey--border">
        <v-select
          v-model="relationship"
          :label="$t('common.activity')"
          :items="relationships"
          single-line
          hide-details
          solo
          flat
        />
      </div>
      <v-spacer />
      <ExcelExporter
        v-if="!isMobile"
        title="Lista de Internos"
        label-field="text"
        :entries="displayedcoordinatedUsers"
        :components="excelHearder"
        :buttonText="`Exportar (${displayedcoordinatedUsers.length})`"
      ></ExcelExporter>
    </v-card-actions>
    <v-divider />
    <v-card flat>
      <v-data-table
        :loading="!usersfectched"
        :headers="headers"
        class="elevation-0"
        :items="displayedcoordinatedUsers"
        :pagination.sync="pagination"
        :search="search"
        :filter="searchFilter"
        :custom-filter="customFilter"
      >
        <template v-slot:items="props">
          <td @click="() => NavigateInternsLogs(props.item.id)">
            {{ props.item.name }}
          </td>
          <td @click="() => NavigateInternsLogs(props.item.id)">
            {{ props.item.license }}
          </td>
          <td @click="() => NavigateInternsLogs(props.item.id)">
            {{ props.item.residencyYear }}
          </td>
          <td @click="() => NavigateInternsLogs(props.item.id)">
            {{ props.item.specialty }}
          </td>
          <td @click="() => NavigateInternsLogs(props.item.id)">
            {{ props.item.hospital }}
          </td>
          <td @click="() => NavigateInternsLogs(props.item.id)">
            {{ props.item.email }}
          </td>
        </template>
      </v-data-table>
    </v-card>
  </v-card>
</template>

<script>
import { CoordinatedUsers } from '../../models/CoordinatedUsers'
import specialtyFetcher from '@/mixins/specialtyFetcher'
import ExcelExporter from '@/components/data-exporter/ExcelExporter'
import { Hospital } from '../../models/Content'
import cms from '@/content'
import _ from 'lodash'
export default {
  components: {
    ExcelExporter
  },
  mixins: [specialtyFetcher],
  data() {
    return {
      search: '',
      relationship: '',
      hospitals: [],
      pagination: {},
      usersfectched: false,
      headers: [
        { text: 'Nome', value: 'name', id: 'name' },
        { text: 'Licença', value: 'license', id: 'license' },
        { text: 'Ano Internato', value: 'residencyYear', id: 'residencyYear' },
        { text: 'Especialidade', value: 'specialty', id: 'specialty' },
        { text: 'Hospital', value: 'hospital', id: 'hospital' },
        { text: 'Email', value: 'email', id: 'email' }
      ],
      roles: cms.getRoles(this.$i18n.locale)
    }
  },

  computed: {
    relationships() {
      const relashionships = this.coordinatedUsers.map(r => ({
        value: r.relationShip,
        text: this.getRoleName(r.relationShip)
      }))
      return relashionships
    },
    excelHearder() {
      return this.headers
    },

    coordinatedUsers() {
      const users = CoordinatedUsers.query()
        .get()
        .filter(i => i.id != this.$store.getters.profile.id)
      return users
    },
    displayedcoordinatedUsers() {
      const users = _.orderBy(this.coordinatedUsers, ['firstName', 'lastName'])
        .filter(i => i.id != this.$store.getters.profile.id)
        .map(i => ({
          ...i,
          name: i.firstName + ' ' + i.lastName,
          residencyYear: this.getResidencyYear(i.residencyStart),
          specialty: this.getSpecialtyName(i.specialty),
          hospital: this.getHospitalName(i.hospital)
        }))
      return users.filter(u => u.relationShip === this.relationship)
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    }
  },
  methods: {
    customFilter(logs, pattern, filter) {
      return logs.filter(l => filter(l, pattern))
    },
    searchFilter(logRow, pattern) {
      return (
        !pattern ||
        Object.values(logRow).some(val =>
          String(val).toLowerCase().includes(pattern)
        )
      )
    },
    getHospitalName(value) {
      const hospital = Hospital.query().whereId(value).first() || {}
      return hospital ? hospital.text : value
    },
    getSpecialtyName(value) {
      return cms.getSpecialtyById(value, this.$i18n.locale)
    },
    getRoleName(value) {
      const role = this.roles.find(i => i.value === value)
      return role ? role.text : value
    },
    getResidencyYear(value) {
      if (!value) {
        return 0
      } else {
        const [year, month] = value.split('-')
        const startDate = new Date(year, month - 1)
        let residencyYear = new Date().getFullYear() - startDate.getFullYear()

        residencyYear = residencyYear === 0 ? 1 : residencyYear

        if (
          new Date().getFullYear() > startDate.getFullYear() &&
          new Date().getMonth() - startDate.getMonth() >= 0
        ) {
          residencyYear++
        }

        return residencyYear ? residencyYear : 0
      }
    },
    NavigateInternsLogs(userId) {
      return this.$router.push({
        name: 'Coordination',
        params: { coordinatedUser: userId }
      })
    }
  },

  async created() {
    await Promise.all([
      CoordinatedUsers.fetch(
        this.$store.getters.accessToken,
        this.$store.getters.user.roles,
        this.$store.getters.user.email,
        this.$store.getters.user.hospital,
        this.$store.getters.user.specialty
      ),
      this.fetchSpecialty()
    ]).catch(err => {
      return this.$store.dispatch(
        'showErrorSnackbar',
        err.message || 'Something went wrong'
      )
    })
    const hospitals = Hospital.query().get()
    if (!hospitals.length) {
      await Hospital.fetch()
    }
    if (this.relationships.length && !this.relationship) {
      this.relationship = this.relationships[0].value
    }
    this.usersfectched = true
  }
}
</script>

<style lang="css">
td span {
  white-space: pre-line;
}
.search-icon {
  cursor: pointer;
}
.search-icon:hover {
  background-color: #f1f1f1;
  cursor: pointer;
}
.filter-number .v-badge__badge {
  top: 2px !important;
  right: 2px !important;
  border: 2px solid #fff !important;
  height: 18px;
  width: 18px;
}
.filter-number .v-badge__badge span {
  position: relative;
  top: 0px;
  font-weight: bold;
  font-size: 10px;
}
</style>
